export default {
    word1: "EBC外匯平台頂級監管的差價合約(CFD)交易商|EBC金融集團",
    word2:
      "EBC金融集團是外匯金融衍生品交易平台，擁有三大監管牌照，提供外匯、股票、指數和大宗商品的差價合約服務，是巴薩官方外匯合作夥伴。EBC旨在為投資者提供安全、專業、高效穩定的服務。",
    word3: "全球最佳券商",
    word4: `EBC金融集團<span class="subtitle-20_medium md-body-14_medium">100+</span>國家投資者信任首選`,
    word5: "槓桿率高達",
    word6: "主流產品",
    word7: "銀行級原始點差",
    word8: "EBC 攜手聯合國基金會抗擊瘧疾",
    word9: `EBC跟單社區<br class="pc"/>免費複製高手`,
    word10: "免費跟隨頂尖交易信號，或成為信號方賺最高 18% 年化收益",
    word11: "公開透明",
    word12: "一鍵跟隨",
    word13: "贏18%年化獎勵",
    word14: "持倉實時同步",
    word15: `EBC金融集團聯合<br class="pc"/>牛津大學研討會`,
    word16: "氣候經濟學如何挖掘投資機會？",
    word17: "立即開戶",
    word18: "了解更多",
    word19: "一鍵交易全球",
    word20:
      "涵蓋全球200+ 主流投資產品，提供機構級流動性和極低點差，成就您的投資之旅",
    word21: "外匯交易",
    word22: "貴金屬及能源",
    word23: "全球股指",
    word24: "美國股票",
    word25: "ETF",
    word26: "交易產品",
    word27: "賣出價",
    word28: "買入價",
    word29: "點差",
    word30: "槓桿",
    word31: "更多產品",
    word32: "87.6%以上的訂單成交於更優價格",
    word33: "EBC的流動性聚合系統在價格、速度與穩定性方面均優於傳統交易模式。",
    word34: "每秒最高媒合訂單",
    word35: "平均執行速度",
    word36: "數據傳輸穩定性",
    word37: "銀行級原始點差",
    word38: "基於百萬次訂單實盤驗證，EBC訂單優化率處於行業前2.5%的水準",
    word39: "開始交易",
    word40: "全球信賴首選 交易更安心 ",
    word41: "頂級監管資質，全面保障體系，讓每一筆交易更安心",
    word42: "全面保障 安心以致",
    word43:
      "我們將資金安全置於首位。EBC英國及開曼將客戶資金獨立托管於英國巴克萊銀行，並通過嚴格遵循英國FCA、開曼CIMA及澳大利亞ASIC監管要求，參與全球政府支持的保障性補償計劃，並通過英國勞合社獲得多項企業專業險，為客戶提供全面安全保障。",
    word44: "EBC全球合作夥伴",
    word45:
      "EBC與25+國際權威銀行及非銀機構建立長期穩定的合作關系，提供真正的機構流動性深度和0.0 Pips同業級別原始點差。此外，EBC聯合牛津大學舉辦研討會、與聯合國基金會攜手打敗瘧疾，並持續與全球合作夥伴合力，積極踐行企業責任，推動建設可持續發展社會。",
    word46: "全球頂級監管",
    word47: "英國FCA監管",
    word48: "EBC Financial Group (UK) Ltd",
    word49: "由英國金融行為監管局 (FCA) 授權和監管。",
    word50: "監管號: 927552",
    word51: "開曼 CIMA 監管",
    word52: "EBC Financial Group (Cayman) Ltd",
    word53: "由開曼群島金融管理局(CIMA)授權和監管。",
    word54: "監管號: 2038223",
    word55: "澳洲 ASIC 監管",
    word56: "EBC Financial Group (Australia) Pty Ltd",
    word57: "由澳大利亞證券和投資委員會 (ASIC) 授權和監管。",
    word58: "監管號: 500991",
    word59:
      "EBC金融集團旗下各公司，在對應司法管轄區域內，均受到嚴格監管並獲得頂級資質許可。 ",
    word60:
      "從成立第一天起，我們就堅持最高的監管合規標準，始終將客戶資產安全置於業務核心，這不僅是我們的承諾，更是不容談判的原則。 ",
    word61:
      "您可以始終相信：我們只與頂級銀行合作，嚴格遵守多地區監管框架，執行業領先的風險管理協議。在安全、透明度和客戶信任方面，我們從未，也永不妥協。 ",
    word62: "全球相伴 交易無憂",
    word63: "無論您身在何處，都能享受真誠專業的金融服務",
    word64: "月均交易量（美金）",
    word65: "註冊用戶",
    word66: "2025第二季度交易訂單優化增益",
    word67: "覆蓋國家",
    word68: "與我們見面",
    word69: "台灣團隊",
    word70: "新動態 新視野 新機會",
    word71:
      "實時獲取EBC最新資訊，金融焦點、市場趨勢、專業觀點，為您篩選最有價值的信息",
    word72: "新聞",
    word73: "合作夥伴",
    word74: "留下您的信息",
    word75: "我們的客戶經理會盡快聯繫您",
    word76: "提交",
    word77: "成交量",
    word78: "滑點",
    word79: "其它",
    word80: "十大最受歡迎券商",
    word81: "最透明交易券商",
    word82: "最受好評券商",
    word83: "卓越執行券商",
    word84: "全球最佳交易體驗獎",
    word85: "最受信賴券商",
    word86: "最佳CFD券商",
    word87: "全球最佳ECN券商",
    word88: "全球新銳券商 ",
    word89: "OMA-最佳券商",
    word90: "最佳外匯交易平台",
    word91: "最佳交易執行",
    word92: "全球最佳券商",
    word93: "貴姓/暱稱",
    word94: "電子信箱",
    word95: "手機號碼",
    word96: "驗證碼",

};
